export default {
  state: () => ({
    iteracion: null,
    ticket: null,
  }),
  mutations: {
    setIteracionAEditar(state, payload) {
      state.iteracion = payload;
    },
    setTicket(state, payload) {
      state.ticket = payload;
    },
  },

  getters: {
    getIteracionAEditar(state) {
      return state.iteracion;
    },
    getTicket(state) {
      return state.ticket;
    },
  },
};
